import { useEffect, useRef } from 'preact/hooks'
import { scrollHistoryManager } from 'helpers/scroll-history'

export function useScrollCache(deps = []) {
  const returned = useRef(false)
  useEffect(() => {
    if (returned.current) return
    // Get the scroll cache data from session storage
    const relevantProduct = scrollHistoryManager.productHandle
    if (!relevantProduct) return
    // Find the target node on the page from the cached product handle
    const resultSelector = `result__${relevantProduct}`
    const resultNode = document.getElementById(resultSelector)

    if (!resultNode) return
    const resultTop = resultNode.getBoundingClientRect().top
    const resultHeight = resultNode.getBoundingClientRect().height
    const offset = resultTop - resultHeight / 2
    // Scroll to the result node
    window.scrollTo({ left: 0, top: offset, behavior: 'instant' })
    scrollHistoryManager.clearScrollHistory()
    returned.current = true
  }, deps)
}
